import React from 'react';
import PropTypes from 'prop-types';

export default class Collapsable extends React.PureComponent {
  static propTypes = {
    isOpen: PropTypes.bool,
    children: PropTypes.node,
  };

  constructor() {
    super();

    this.state = {
      height: 0,
    };

    this._contentRef = this._contentRef.bind(this);
  }

  componentDidMount() {
    const { isOpen } = this.props;

    if (this._content) {
      if (isOpen) {
        this.setState({ height: this._content.clientHeight });
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isOpen !== prevProps.isOpen ||
      (this.props.isOpen && this._content.clientHeight !== this.state.height)
    ) {
      this.setState({ height: this.props.isOpen ? this._content.clientHeight : 0 });
    }
  }

  render() {
    const { height } = this.state;
    const { children } = this.props;
    return (
      <div style={{ height, overflow: height > 0 ? 'visible' : 'hidden' }}>
        <div ref={this._contentRef}>{children}</div>
      </div>
    );
  }

  _contentRef(el) {
    this._content = el;
  }
}
